/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Ignore_Note_PlaceholderInputs */

const vi_reconcile_ignore_note_placeholder = /** @type {(inputs: Reconcile_Ignore_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VD: nạp tiền, hoàn tiền...`)
};

/**

* @param {Reconcile_Ignore_Note_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_ignore_note_placeholder = /** @type {((inputs?: Reconcile_Ignore_Note_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Ignore_Note_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_ignore_note_placeholder(inputs)
});